import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { AuthShell, GoogleButton } from "@/pages/Login";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(name, email, password);
      toast.success("Account created — welcome!");
      navigate("/account", { replace: true });
    } catch (err) {
      toast.error(apiError(err));
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Create your account" subtitle="Start turning your memories into keepsakes.">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="name">Name</Label>
          <Input id="name" required value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name" className="mt-1" placeholder="Your name" />
        </div>
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email" className="mt-1" placeholder="you@example.com" />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password" className="mt-1" placeholder="At least 6 characters" />
        </div>
        <Button type="submit" disabled={busy} data-testid="register-submit" className="w-full rounded-full bg-amber hover:bg-amber-600 text-white font-semibold">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Create account"}
        </Button>
      </form>
      <div className="flex items-center gap-3 my-5"><div className="h-px bg-slate-200 flex-1" /><span className="text-xs text-slate-400">or</span><div className="h-px bg-slate-200 flex-1" /></div>
      <GoogleButton />
      <p className="text-center text-sm text-slate-500 mt-6">Already have an account? <Link to="/login" className="text-amber font-semibold">Sign in</Link></p>
    </AuthShell>
  );
}
